import script from "./AtomTitleWelcome.vue?vue&type=script&lang=ts&setup=true"
export * from "./AtomTitleWelcome.vue?vue&type=script&lang=ts&setup=true"

import "./AtomTitleWelcome.vue?vue&type=style&index=0&id=a112c182&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a112c182"]])

export default __exports__